import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { CartaCreditoGuard } from './guard/carta-credito.guard';
import { EntidadeSelecionadaGuard } from './guard/entidade-selecionada.guard';
import { HomeGuard } from './guard/home.guard';
import { RetificacaoCartaCreditoGuard } from './guard/retificacao-carta-credito.guard';
import {PermissaoAcessoPleitoMctiGuard} from './guard/permissao-acesso-pleito-mcti.guard';
import {PermissaoAcessoPleitoGuard} from './guard/permissao-acesso-pleito.guard';
import { RotaEnum } from './shared/enum/rota.enum';

const routes: Routes = [

  {
    path: 'example',
    loadChildren: './example/example.module#ExampleModule'
  },
  {
    path: RotaEnum.Empresa,
    loadChildren: './empresa/empresa.module#EmpresaModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.IdentificacaoPreenchimento,
    loadChildren: './responsavel-rda/responsavel-rda.module#ResponsavelRdaModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.DeclaracaoRda,
    loadChildren: './declaracao-rda/declaracao-rda.module#DeclaracaoRdaModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.FaturamentoBruto,
    loadChildren: './faturamento-bruto/faturamento-bruto.module#FaturamentoBrutoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard ]
  },
  {
    path: RotaEnum.Projeto,
    loadChildren: './projeto/projeto.module#ProjetoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.FaturamentoProduto,
    loadChildren: './produto/produto.module#ProdutoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.DispendioEquipamentoSoftware,
    loadChildren: './dispendio-equipamento-software/dispendio-equipamento-software.module#DispendioEquipamentoSoftwareModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.DispendioOutro,
    loadChildren: './dispendio-outro/dispendio-outro.module#DispendioOutroModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.DispendioRecursoHumano,
    loadChildren: './dispendio-recurso-humano/dispendio-recurso-humano.module#DispendioRecursoHumanoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.AnexoDocumentoRda,
    loadChildren: './anexo-documento-rda/anexo-documento-rda.module#AnexoDocumentoRdaModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.ObrigacaoAplicacao,
    loadChildren: './obrigacao-aplicacao/obrigacao-aplicacao.module#ObrigacaoAplicacaoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.ValidaRda,
    loadChildren: './rda/valida-rda/valida-rda.module#ValidaRdaModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.RelatorioConclusivo,
    loadChildren: './auditoria/relatorio-conclusivo/relatorio-conclusivo.module#RelatorioConclusivoModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.ConfiguracaoParametro,
    loadChildren: './configura-parametro/configura-parametro.module#ConfiguraParametroModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.GerarCartaCredito,
    loadChildren: './carta-credito/carta-credito.module#CartaCreditoModule',
    canActivate: [HomeGuard,
      EntidadeSelecionadaGuard,
      CartaCreditoGuard
    ]
  },
  {
    path: RotaEnum.RetificarCartaCredito,
    loadChildren: './retificar-carta-credito/retificar-carta-credito.module#RetificarCartaCreditoModule',
    canActivate: [HomeGuard,
      EntidadeSelecionadaGuard,
      RetificacaoCartaCreditoGuard
    ]
  },
  {
    path: RotaEnum.GerirEntidade,
    loadChildren: './gerir-entidade/gerir-entidade.module#GerirEntidadeModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.GerirStatus,
    loadChildren: './gerir-status/gerir-status.module#GerirStatusModule',
    canActivate: [HomeGuard, PermissaoAcessoPleitoMctiGuard]
  },
  {
    path: RotaEnum.TermosCarta,
    loadChildren: './termo-carta-credito/termo-carta-credito.module#TermoCartaCreditoModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.TermosRetificacaoCarta,
    loadChildren: './termo-carta-credito/termo-carta-credito.module#TermoCartaCreditoModule',
    canActivate: [HomeGuard]
  },
  {
    path: RotaEnum.GerirProduto,
    loadChildren: './gerir-produto/gerir-produto.module#GerirProdutoModule'
  },
  {
    path: RotaEnum.VincularContratante,
    loadChildren: './vincular-contratante/vincular-contratante.module#VincularContratanteModule',
    canActivate: [HomeGuard, EntidadeSelecionadaGuard]
  },
  {
    path: RotaEnum.GerirPleito,
    loadChildren: './gerir-pleito/gerir-pleito.module#GerirPleitoModule',
    canActivate: [PermissaoAcessoPleitoGuard]
  },
  {
    path: RotaEnum.GerirPleitoMCTI,
    loadChildren: './gerir-pleito-mcti/consultar-pleito-mcti/consultar-pleito-mcti.module#ConsultarPleitoMctiModule',
    canActivate: [PermissaoAcessoPleitoMctiGuard]
  },
  {
    path: RotaEnum.FiscalizacaoElaborarParecer,
    loadChildren: './elaborar-parecer/elaborar-parecer.module#ElaborarParecerModule',
    canActivate: [HomeGuard]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: NoPreloading,
      scrollPositionRestoration: 'top',
      enableTracing: environment.enableRouteTracing
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
